<template>
  <section>
    <b-form-row>
      <b-col>
        <van-divider
          :style="{ color: 'blue', borderColor: 'blue', 'font-size': '1.5em' }"
        >{{ $t('dharma-application-form.applicant.delivery.title') }}</van-divider>
      </b-col>
    </b-form-row>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.object')"
      label-size="lg"
      label-for="object"
    >
      <b-form-select id="object" v-model="delivery.object">
        <template #first>
          <b-form-select-option value="" disabled>{{ $t('dharma-application-form.applicant.delivery.object-selector.hint') }}</b-form-select-option>
        </template>
        <b-form-select-option value="agent">{{ $t('dharma-application-form.applicant.delivery.object-selector.option.agent') }}</b-form-select-option>
        <b-form-select-option value="principal">{{ $t('dharma-application-form.applicant.delivery.object-selector.option.principal') }}</b-form-select-option>
        <!-- <b-form-select-option value="cvs">{{ $t('dharma-application-form.applicant.delivery.object-selector.option.cvs') }}</b-form-select-option> -->
      </b-form-select>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.area')"
      label-size="lg"
      label-for="area"
      v-if="delivery.object && delivery.object !== 'cvs'"
    >
      <b-form-select id="area" v-model="delivery.area">
        <template #first>
          <b-form-select-option value="" disabled>{{ $t('dharma-application-form.applicant.delivery.area-selector.hint') }}</b-form-select-option>
        </template>
        <b-form-select-option
          :value="area.english_name"
          v-for="(area, index) in areas"
        >{{ $i18n.locale === 'tw' ? area.chinese_name : area.english_name }}</b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.customs-duty-option')"
      label-size="lg"
      label-for="customs_duty_option"
      v-if="delivery.area && delivery.area !== 'Taiwan'"
    >
      <b-form-text
        tag="p"
        text-variant="warning"
        class="font-weight-bold"
        v-html="$t('dharma-application-form.applicant.delivery.instruction-text.customs-duty-option')"
        v-if="is_bulk_application"
      ></b-form-text>
      <b-form-select id="customs_duty_option" v-model="delivery.customs_duty_option">
        <template #first>
          <b-form-select-option value="" disabled>{{ $t('dharma-application-form.applicant.delivery.customs-duty-option-selector.hint') }}</b-form-select-option>
        </template>
        <b-form-select-option
          :value="customs_duty_option.key"
          v-for="(customs_duty_option, index) in customs_duty_options"
        >{{ customs_duty_option[`label-${$i18n.locale}`] }}</b-form-select-option>
      </b-form-select>
      <b-form-text
        tag="p"
        text-variant="danger"
        class="font-weight-bold"
        v-html="$t('dharma-application-form.applicant.delivery.disclaimer-text.customs-duty-option.unable-to-pay')"
        v-if="delivery.customs_duty_option === 'unable-to-pay' && !is_bulk_application"
      ></b-form-text>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.shipping-cost-option')"
      label-size="lg"
      label-for="shipping_cost_option"
      v-if="delivery.area === 'China Mainland'"
    >
      <b-form-select id="shipping_cost_option" v-model="delivery.shipping_cost_option">
        <template #first>
          <b-form-select-option value="" disabled>{{ $t('dharma-application-form.applicant.delivery.shipping-cost-option-selector.hint') }}</b-form-select-option>
        </template>
        <b-form-select-option
          :value="shipping_cost_option.key"
          v-for="(shipping_cost_option, index) in shipping_cost_options"
        >{{ shipping_cost_option[`label-${$i18n.locale}`] }}</b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group 
      :label="$t('dharma-application-form.applicant.delivery.label.shipping-cost-option-description')"
      label-size="lg"
      label-for="shipping_cost_option_description"
      v-if="delivery.area === 'China Mainland' && delivery.shipping_cost_option === 'unable-to-cover-shipping-cost'"
    >
      <b-form-textarea
        trim
        id="shipping_cost_option_description"
        v-model="delivery.shipping_cost_option_description"
      ></b-form-textarea>
      <b-form-text tag="p" text-variant="primary" class="font-weight-bold">
        {{ $t('dharma-application-form.applicant.delivery.instruction-text.shipping-cost-option-description') }}
      </b-form-text>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.nearest-available-port')"
      label-size="lg"
      label-for="nearest_available_port"
      v-if="is_bulk_application && delivery.area && delivery.area !== 'Taiwan'"
    >
      <b-form-input id="nearest_available_port" v-model="delivery.nearest_available_port" trim></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.can-clear-customs')"
      label-size="lg"
      label-for="can_clear_customs"
      v-if="is_bulk_application && delivery.area && delivery.area !== 'Taiwan'"
    >
      <b-form-select id="can_clear_customs" v-model="delivery.can_clear_customs">
        <b-form-select-option value="Y">{{ $t('dharma-application-form.applicant.delivery.option.yes') }}</b-form-select-option>
        <b-form-select-option value="N">{{ $t('dharma-application-form.applicant.delivery.option.no') }}</b-form-select-option>
      </b-form-select>
      <b-form-text
        tag="p"
        text-variant="warning"
        class="font-weight-bold"
        v-html="$t('dharma-application-form.applicant.delivery.disclaimer-text.can_clear_customs.no')"
        v-if="delivery.can_clear_customs === 'N'"
      ></b-form-text>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.postal-code')"
      label-size="lg"
      label-for="postal_code"
      v-if="delivery.object && delivery.object !== 'cvs'"
    >
      <b-form-input id="postal_code" autocomplete="postal-code" v-model="delivery.postal_code" trim></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.address')"
      label-size="lg"
      v-if="delivery.object && delivery.object !== 'cvs'"
    >
      <template v-if="$i18n.locale === 'tw'">
        <b-form-group label-for="city">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.city') }}</h5></slot>
          <b-form-input
            trim
            id="city"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level2' : 'address-level1'"
            v-model="delivery.city"
          ></b-form-input>
          <b-form-text tag="p" text-variant="warning" class="font-weight-bold" v-if="delivery_to_taipei_area">
            {{ $t('dharma-application-form.applicant.delivery.reminder-text.city.can-apply-at-the-counter') }}
          </b-form-text>
        </b-form-group>
        <b-form-group label-for="district">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.district') }}</h5></slot>
          <b-form-input
            trim
            id="district"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level3' : 'address-level2'"
            v-model="delivery.district"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-for="street_address">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.street-address') }}</h5></slot>
          <b-form-input
            trim
            id="street_address"
            autocomplete="street-address"
            v-model="delivery.street_address"
          ></b-form-input>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group label-for="street_address">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.street-address') }}</h5></slot>
          <b-form-input
            trim
            id="street_address"
            autocomplete="street-address"
            v-model="delivery.street_address"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-for="district">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.district') }}</h5></slot>
          <b-form-input
            trim
            id="district"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level3' : 'address-level2'"
            v-model="delivery.district"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-for="city">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.city') }}</h5></slot>
          <b-form-input
            trim
            id="city"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level2' : 'address-level1'"
            v-model="delivery.city"
          ></b-form-input>
          <b-form-text tag="p" text-variant="warning" class="font-weight-bold" v-if="delivery_to_taipei_area">
            {{ $t('dharma-application-form.applicant.delivery.reminder-text.city.can-apply-at-the-counter') }}
          </b-form-text>
        </b-form-group>
      </template>
      <b-form-row v-if="delivery.area">
        <b-col>
          <p class="text-primary font-weight-bold">
            {{ $t('dharma-application-form.applicant.delivery.help-text.address') }}
          </p>
        </b-col>
      </b-form-row>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.cvs-code')"
      label-size="lg"
      label-for="cvs_code"
      v-if="delivery.object === 'cvs'"
    >
      <b-form-input id="cvs_code" v-model="delivery.info.cvs_code" trim></b-form-input>
      <b-button
        block
        href="http://map.ezship.com.tw/"
        target="_blank"
        variant="outline-info"
      >{{ $t('dharma-application-form.applicant.delivery.button.cvs-code-inquiry.label') }}</b-button>
      <b-button
        block
        href="http://www-old.budaedu.org/books/apply/note.pdf"
        target="_blank"
        variant="bg-transparent"
      >{{ $t('dharma-application-form.applicant.delivery.button.cvs-code-pickup-service-instructions.label') }}</b-button>
    </b-form-group>
    <b-form-row v-if="Object.keys(validation_results.delivery).length > 0">
      <b-col class="text-danger">
        <p
          class="font-weight-bold"
          v-for="field in validation_results.delivery.fieldErrors"
        >{{ field.message }}</p>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <van-divider
          :style="{ color: 'green', borderColor: 'green', 'font-size': '1.5em' }"
        >{{ $t('dharma-application-form.applicant.contact.title') }}</van-divider>
      </b-col>
    </b-form-row>
    <b-tabs content-class="mt-3" pills fill>
      <b-tab :title="$t('dharma-application-form.applicant.contact.agent.title')" active>
        <agent-form
          :delivery="delivery"
          :form_data="form_data.agent_applicant"
          :is-bulk-application="is_bulk_application"
          ref="agent_form"
        ></agent-form>
      </b-tab>
      <b-tab :title="$t('dharma-application-form.applicant.contact.principal.title')">
        <principal-form
          :delivery="delivery"
          :form_data="form_data.principal_applicant"
          :is-bulk-application="is_bulk_application"
          ref="principal_form"
        ></principal-form>
      </b-tab>
    </b-tabs>
  </section>
</template>
<script>
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

import { ButtonPlugin } from 'bootstrap-vue'
import { Divider } from 'vant'
import { FormGroupPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { Validators, createFormValidation } from '@lemoncode/fonk'
import { requiredByField } from '@lemoncode/fonk-required-by-field-validator'

import i18n from '@/plugins/i18n.js'

import ContainsNoChineseCharactersValidator from '@/services/fonk-validation-service/contains-no-chinese-characters-validator'
import DharmaDeliveryAreaApiService from '@/services/budaedu-api-services/dharma-delivery-area-api-service.js'

import AgentForm from './AgentForm'
import PrincipalForm from './PrincipalForm'

Vue.use(ButtonPlugin)
Vue.use(Divider)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(LayoutPlugin)
Vue.use(VueLocalStorage)

Vue.use(DharmaDeliveryAreaApiService)

export default {
  i18n,
  name: 'proxy-form',
  props: {
    form_data: {
      type: Object,
      default: () => ({
        delivery: {},
        agent_applicant: {},
        principal_applicant: {}
      })
    },
    is_bulk_application: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      areas: [],
      customs_duty_options: [],
      shipping_cost_options: [],
      delivery: {
        object: '',
        area: '',
        postal_code: '',
        city: '',
        district: '',
        street_address: '',
        customs_duty_option: '',
        shipping_cost_option: '',
        shipping_cost_option_description: '',
        nearest_available_port: '',
        can_clear_customs: '',
        info: {
          cvs_code: ''
        }
      },
      validation_results: {
        delivery: {}
      }
    }
  },
  watch: {
    form_data: {
      handler(new_value) {
        if (new_value) {
          if (new_value.delivery) {
            this.delivery = { ...this.delivery, ...new_value.delivery }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    delivery_to_taipei_area() {
      if (!this.delivery.city) {
        return false
      }
      return /(臺北|台北|Taipei)/i.test(this.delivery.city)
    },
    validation_schema() {
      return {
        field: {
          object: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.delivery.error-message.object.required')
          }],
          area: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.delivery.error-message.area.required')
          }],
          postal_code: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.delivery.error-message.postal-code.required')
          }],
          city: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.city.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.city.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          district: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.district.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.district.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          street_address: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.street-address.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.street-address.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          customs_duty_option: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              condition: (value) => value && value !== 'Taiwan'
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.customs-duty-option.required')
          }],
          shipping_cost_option: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              value: 'China Mainland',
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.shipping-cost-option.required')
          }],
          shipping_cost_option_description: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              condition: (value, values) => value === 'China Mainland' && values.shipping_cost_option === 'unable-to-cover-shipping-cost'
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.shipping-cost-option-description.required')
          }],
          can_clear_customs: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              condition: (value) => value && value !== 'Taiwan' && this.is_bulk_application
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.can-clear-customs.required')
          }],
          "info.cvs_code": [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.delivery.error-message.cvs-code.required')
          }]
        }
      }
    }
  },
  methods: {
    async validateForm() {
      const is_delivery_form_valid = await this.validateDeliveryForm()
      const is_applicant_form_valid = await this.validateApplicantForm()
      return is_delivery_form_valid && is_applicant_form_valid
    },
    async validateDeliveryForm() {
      let validation_schema = null
      if (this.delivery.object) {
        validation_schema = (this.delivery.object === 'cvs')
          ? this.getValidationSchemaByFieldName(['object', 'info.cvs_code'])
          : this.getValidationSchemaByFieldName([
              'object', 'area', 'postal_code', 'city', 'district', 'street_address',
              'customs_duty_option', 'shipping_cost_option', 'shipping_cost_option_description',
              'can_clear_customs'
            ])
      } else {
        validation_schema = this.getValidationSchemaByFieldName(['object'])
      }
      
      const validation = createFormValidation(validation_schema)
      await validation
        .validateForm(this.delivery)
        .then(form_validation_result => {
          this.validation_results.delivery = form_validation_result
        })
      return this.validation_results.delivery.succeeded
    },
    async validateApplicantForm() {
      const is_agent_form_valid = await this.$refs['agent_form'].validateForm()
      const is_principal_form_valid = await this.$refs['principal_form'].validateForm()
      return is_agent_form_valid && is_principal_form_valid
    },
    getValidationSchemaByFieldName(field_name) {
      const field_validation_schema = field_name.reduce((field_validation_schema, key) => {
        if (this.validation_schema.field.hasOwnProperty(key)) {
          field_validation_schema[key] = this.validation_schema.field[key];
        }
        return field_validation_schema;
      }, {});

      return { field: field_validation_schema }
    },
    async setAreas() { 
      const items = await this.$dharmaDeliveryAreaApiService.query('filter[can_deliver]=Y&order=priority,asc|english_name,asc')
      this.areas = items.data
    },
    async setCustomsDutyOptions() {
      const item = await this.$constantApiService.getFromMemberSystem()
      this.customs_duty_options = item.data.customs_duty_options
    },
    async setShippingCostOptions() { 
      const item = await this.$constantApiService.getFromMemberSystem()
      this.shipping_cost_options = item.data.shipping_cost_options
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setAreas()
    await this.setCustomsDutyOptions()
    await this.setShippingCostOptions()
  },
  components: {
    AgentForm,
    PrincipalForm
  }
}
</script>